import { IState } from "../store/state";
import { promiseValidResponse } from "../utils/promiseValidResponse";
import { promiseStatsTeamLastX, promiseStatsPlayerAggregate, promiseStatsTeamVersusRecent, promiseMatchEventsDelta, promiseMatchOdds } from "./feedPromises";
import { getPhaseIdByMatchId, getActiveMatchId } from "../reducers/timings";
import { getLastEventIdByMatchId } from "../reducers/matches";
import { processOddsData, getExpirationDateByMatchId } from "../reducers/odds";
import { getInitApplicationState } from "../reducers/gui";
import { PHASE_POST_POINT } from "./phases";

export const promiseStatsTeamLastXCombinedValidated = (state: IState, teamIdA: number, teamIdB: number, channel: number, numMatches: number = 5) : Promise<any> => {
    return new Promise<any>( ( resolve, reject ) => {
        Promise.all( [
            promiseStatsTeamLastXValidated(state,teamIdA,numMatches),
            promiseStatsTeamLastXValidated(state,teamIdB,numMatches),
        ] )
        .then( ( responses: any[] ) => resolve( { data: { [channel]: responses.map( (response: any) => response.data ) } } ) )
        .catch( error => reject(error) );
    } );
}

export const promiseStatsPlayerAggregateCombinedValidated = (state: IState, tournamentId: number, teamIdA: number, teamIdB: number, matchId: number, channel: number) : Promise<any> => {
    return new Promise<any>( ( resolve, reject ) => {
        Promise.all( [
            promiseStatsPlayerAggregateValidated(state,tournamentId,teamIdA,matchId),
            promiseStatsPlayerAggregateValidated(state,tournamentId,teamIdB,matchId),
        ] )
        .then( ( responses: any[] ) => resolve( {data: { [channel]: responses.map( (response: any) => response.data ) } } ) )
        .catch( error => reject(error) );
    } );
}

export const promiseStatsTeamLastXValidated = (state: IState, teamIdA: number, numMatches: number = 5) : Promise<any> =>
    promiseValidResponse(
        'StatsTeamLastX',
        () => promiseStatsTeamLastX(state,teamIdA,numMatches),
        response => !!(response.data.doc && response.data.doc[0] && response.data.doc[0].data && response.data.doc[0].data.matches)
    );

export const promiseStatsPlayerAggregateValidated = (state: IState, tournamentId: number, teamId: number, matchId: number) : Promise<any> => 
    promiseValidResponse(
        'StatsPlayerAggregate',
        () => promiseStatsPlayerAggregate(state,tournamentId,teamId,matchId),
        response => !!(response.data.doc && response.data.doc[0] && response.data.doc[0].data && response.data.doc[0].data.all && response.data.doc[0].data.all.last_tiebreak_games_won)
    );

export const promiseStatsTeamVersusRecentValidated = (state: IState, teamIdA: number, teamIdB: number, channel: number, numMatches: number = 5) : Promise<any> => 
    promiseValidResponse(
        'StatsTeamVersusRecent',
        () => promiseStatsTeamVersusRecent(state,teamIdA,teamIdB,channel,numMatches),
        response => !!(response.data[channel] && response.data[channel].doc && response.data[channel].doc[0] && response.data[channel].doc[0].data && response.data[channel].doc[0].data.matches)
    );

export const promiseMatchEventsDeltaValidated = (state: IState, matchId: number) : Promise<any> => 
    promiseValidResponse(
        'MatchEventsDelta',
        () => promiseMatchEventsDelta(state,matchId),
        response => {
            const valid = !!(response.data.doc && response.data.doc[0] && response.data.doc[0].data && response.data.doc[0].data.events &&
            (getPhaseIdByMatchId(state,matchId)!==PHASE_POST_POINT||response.data.doc[0].data.events.length!=0));
            
            if( valid && !(response.data.doc[0].data.events.length == 0 ||
                getLastEventIdByMatchId(state,matchId)!=response.data.doc[0].data.events[response.data.doc[0].data.events.length-1]._id)
            ) {
                //console.warn( 'MatchEventsDelta: Response is out of date' );
                return false;
            }
            return valid;
        }
    );

export const promiseMatchOddsValidated = (state: IState, matchId: number) : Promise<any> => 
    promiseValidResponse(
        'MatchOdds',
        () => promiseMatchOdds(state,matchId),
        response => {
            const feedOdds = processOddsData(response.data);
            const matchId = Number(Object.keys(feedOdds)[0]);
  
            const nextExpirationDate = feedOdds[matchId].expirationDate;
            const currentExpirationDate = getExpirationDateByMatchId(state,matchId);
            const isApplicationReady = getInitApplicationState(state);

            if( !isApplicationReady ) {
                return true;
            }
            if( matchId == getActiveMatchId(state) ) {
                //console.log( 'activeMatchId', getActiveMatchId(state), 'currentExpirationDate', currentExpirationDate, 'nextExpirationDate', nextExpirationDate );
            }
            if( nextExpirationDate == currentExpirationDate ) {
                //console.warn( 'MatchOdds: Response is out of date' );
            }
            return nextExpirationDate !== currentExpirationDate;
        }
    );